import { render, staticRenderFns } from "./tweets.vue?vue&type=template&id=43ffc810&scoped=true"
import script from "./tweets.vue?vue&type=script&lang=js"
export * from "./tweets.vue?vue&type=script&lang=js"
import style0 from "./tweets.vue?vue&type=style&index=0&id=43ffc810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffc810",
  null
  
)

export default component.exports